const { trackGtm } = require('../../../../js/functions');

module.exports = {
	init() {
		const topicMainLink = this.root.querySelector(
			'.topic-highlight--link-container',
		);
		const highlights = this.root.querySelectorAll('.highlight');
		let mainHref = topicMainLink.querySelector(
			'.box-article-content--link',
		).href;
		topicMainLink.addEventListener('click', () => {
			trackGtm({
				eventCategory: 'cta',
				eventAction: 'read',
				eventLabel: mainHref,
			});
		});

		highlights.forEach(element => {
			let href = element.querySelector('.box-article-content--link').href;
			element.addEventListener('click', () => {
				trackGtm({
					eventCategory: 'cta',
					eventAction: 'image',
					eventLabel: href,
				});
			});
		});
	},
};
